import * as React from "react";

function SvgFacebook(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 11.067c0-6.075-4.925-11-11-11s-11 4.925-11 11c0 5.49 4.022 10.041 9.281 10.866v-7.686H6.488v-3.181h2.793V8.644c0-2.756 1.643-4.28 4.155-4.28 1.203 0 2.463.216 2.463.216v2.707H14.51c-1.367 0-1.793.847-1.793 1.717v2.063h3.05l-.487 3.18h-2.563v7.687C17.978 21.108 22 16.557 22 11.067z"
        fill="#000"
      />
    </svg>
  );
}

export default SvgFacebook;
